export default {
  namespaced: true,
  state: {},
  actions: {},
  mutations:{},
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/default.js